import { useFormContext } from 'react-hook-form'

import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/AddFundForm/AddFundForm.schema'

export interface AddFundFormFieldsProps {}

export const AddFundFormFields: React.FC<AddFundFormFieldsProps> = ({}) => {
  const { control, formState, register } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="fund_name"
        control={control}
        render={() => {
          return (
            <FormItem>
              <FormLabel>Fund Name</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                {...register('fund_name')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="fund_long_name"
        control={control}
        render={() => {
          return (
            <FormItem>
              <FormLabel>Fund Long Name</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                {...register('fund_long_name')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="currency"
        control={control}
        render={() => {
          return (
            <FormItem>
              <FormLabel>Currency</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                {...register('currency')}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="platform_name"
        control={control}
        render={() => {
          return (
            <FormItem>
              <FormLabel>Platform Name</FormLabel>
              <Input
                inputSize={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                {...register('platform_name')}
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
